import { Box, Card, CardProps, Skeleton, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { forwardRef } from "react"

export const VerticalSkeletonDirectoryCard = forwardRef<
  HTMLDivElement,
  CardProps
>(({ sx = {}, ...props }, ref) => {
  const theme = useTheme()
  const { styleOverrides = {} } =
    theme.components?.[`VerticalSkeletonDirectoryCard`] || {}
  const { root, avatar, cardContent, primaryText, secondaryText } =
    styleOverrides
  return (
    <Card sx={deepmerge(root, sx)} ref={ref} {...props}>
      <Skeleton sx={avatar} variant="rectangular" />
      <Box sx={cardContent}>
        <Skeleton sx={primaryText} variant="text" width="80%" />
        <Skeleton sx={secondaryText} variant="text" width="60%" />
      </Box>
    </Card>
  )
})
